import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "angle-up",
  "use": "angle-up-usage",
  "viewBox": "0 0 18 28",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 28\" id=\"angle-up\"><path d=\"M16.797 18.5a.54.54 0 01-.156.359l-.781.781a.508.508 0 01-.359.156.54.54 0 01-.359-.156l-6.141-6.141L2.86 19.64c-.094.094-.234.156-.359.156s-.266-.063-.359-.156l-.781-.781c-.094-.094-.156-.234-.156-.359s.063-.266.156-.359l7.281-7.281c.094-.094.234-.156.359-.156s.266.063.359.156l7.281 7.281a.536.536 0 01.156.359z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol